module.exports = __webpack_public_path__ + "static/media/logo_black_icon.2a0fb846.png";